<script setup lang="ts">
const { lite } = defineProps<{
    lite?: boolean;
}>();
const route = useRoute();

const isHotel = computed(() => route.path === '/hotel');
</script>

<template>
    <div class="container tickets-wrap">
        <p v-show="!isHotel && !lite">
            مِستربلیط یکی از بزرگ‌ترین پلتفرم‌های آنلاین فروش بلیط سفر است؛ جایی
            که تلاش کرده‌ایم همه نیازهای سفر شما را از
            <a href="https://mrbilit.com/international-flights">
                خرید بلیط هواپیما خارجی
            </a>
            ، داخلی، قطار و اتوبوس گرفته تا رزرو هتل را به صورت یکجا برطرف کنیم.
            مِستربلیط نماد اعتماد الکترونیک دو ستاره را از مرکز توسعه تجارت
            الکترونیک دارد و زیر نظر نهادهای رسمی فعالیت می‌کند. علاوه‌بر
            وب‌سایت، اپلیکیشن مِستربلیط برای گوشی‌های اندروید و iOS نیز در دسترس
            است. شما می‌توانید با جست‌جوی سریع و مقایسه قیمت‌ها، انواع بلیط‌ها
            را مانند
            <a href="https://mrbilit.com/charter">بلیط هواپیما چارتری</a>
            ، سیستمی، قطار، اتوبوس یا حتی
            <a href="https://mrbilit.com/flights/lastsecond">بلیط لحظه آخری</a>
            خود را از ما خریداری کنید.
        </p>
    </div>
</template>

<style scoped lang="scss">
// fix need for typography
.tickets-wrap {
    margin: 0 auto;
    .title {
        margin: 0 0 7.5px 0;
    }

    h3,
    b {
        margin: 16px 0;
        // text
        font-style: normal;
        @include font-weight(bold);
        font-size: 18px;
        line-height: 28px;
        text-align: right;
        color: usePalette($p-cool-gray, $p-800);
    }

    p {
        font-style: normal;
        @include font-weight(300);
        font-size: 12px;
        line-height: 19px;
        text-align: center;
        color: usePalette($p-cool-gray, $p-800);
    }

    a {
        color: usePalette() !important;
        text-decoration: none !important;
    }
}

// plane tickets

@media (max-width: $app-mobile-max-width) {
    .tickets-wrap {
        padding: 0 16px;
        @include mobile-only {
            padding: 0;
            > * {
                padding-left: 16px;
                padding-right: 16px;
            }
            > a {
                display: block;
            }
        }
    }

    .tickets-wrap p {
        text-align: justify;
    }
}
</style>
